import { useEffect, useRef, useState } from "react";
import { Circle, MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import Mycomponent from "./Mycomponent.js";
import { Icon } from "leaflet";
let module = require("../data.js");
const Green = new Icon({
  iconUrl:
    "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|ff3c00&chf=a,s,ee00FFFF",
  iconAnchor: [10, 35],
  popupAnchor: [0, -34],
});
const Blueicon = new Icon({
  iconUrl:
    "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|abcdef&chf=a,s,ee00FFFF",
  iconAnchor: [10, 35],
  popupAnchor: [0, -34],
});

function Map() {
  const mapref = useRef();
  const [nearestInd, setnearestInd] = useState("");
  const [distance, setdistance] = useState(0);
  const [constdistance, setconstdistance] = useState(0);
  const [intId, setintId] = useState("");
  let data = module.dataArr;
  function getnearhospital(arr_index) {
    setnearestInd(arr_index[0]);
    setdistance(0);
    setconstdistance(arr_index[1]);
    let id = increasingrad(arr_index[1]);
    setintId(id);
    if (arr_index[1] !== distance) {
      // console.log(distance);
      clearInterval(intId);
    }
  }
  function increasingrad(dist) {
    const frames = 70;
    let speed = 1000 / frames;
    let start = 1;
    let ininterval = setInterval(() => {
      if (start > frames - 1) {
        start = 1;
      } else {
        start += 1;
        setdistance(0 + (dist * start) / frames);
      }
    }, speed);
    return ininterval;
  }
  return (
    <>
      <MapContainer ref={mapref} center={[22.3072, 73.1812]} zoom={13}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {/* <Marker position={[newLatLng.lat, newLatLng.lng]}></Marker> */}
        {data.map((hospital, index) => {
          return (
            <>
              {index === nearestInd ? (
                <>
                  <Marker
                    icon={Green}
                    key={hospital.Sl_No}
                    position={[hospital.Lat, hospital.Lng]}
                  >
                    <Popup>
                      <h4>{hospital.Hospital_Names.split(",")[0]}</h4>
                      <p className="address">
                        {hospital.Hospital_Names.split(",").slice(1)}
                      </p>
                    </Popup>
                  </Marker>
                  <Circle
                    center={[hospital.Lat, hospital.Lng]}
                    radius={constdistance * 1000}
                    color={"red"}
                    stroke={false}
                    weight={1}
                    fillOpacity={0.2}
                  ></Circle>
                  <Circle
                    center={[hospital.Lat, hospital.Lng]}
                    radius={distance * 1000}
                    color={"red"}
                    // stroke={false}
                    weight={1}
                    opacity={0.5}
                    fillOpacity={0.1}
                  ></Circle>
                </>
              ) : (
                <Marker
                  icon={Blueicon}
                  key={hospital.Sl_No}
                  position={[hospital.Lat, hospital.Lng]}
                >
                  <Popup>
                    <h4>{hospital.Hospital_Names.split(",")[0]}</h4>
                    <p className="address">
                      {hospital.Hospital_Names.split(",").slice(1)}
                    </p>
                  </Popup>
                </Marker>
              )}
            </>
          );
        })}
        <Mycomponent
          parentcallback={getnearhospital}
          // newMarker={Addnewmarker}
        />
      </MapContainer>
    </>
  );
}

export default Map;

// function NewMarker(props) {
//   let { hospital } = props;
//   return (
//     <Marker icon={Green} position={[hospital.Lat, hospital.Lng]}>
//       <Popup>
//         <h4>{hospital.Hospital_Names.split(",")[0]}</h4>
//         <p className="address">{hospital.Hospital_Names.split(",").slice(1)}</p>
//       </Popup>
//     </Marker>
//   );
// }
